import React from 'react'

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Icon from '@material-ui/core/Icon';
import { DateRangePicker } from 'react-dates';

class DRP extends React.Component {
	state={
		startDate: null,
		endDate: null,
		focusedInput: null
	}

	handleChange(e) {
		const { startDate, endDate } = e
		this.setState({ startDate, endDate })
		this.props.handleChange({
			from: {...startDate},
			to: {...endDate}
		})
	}

	resetDates() {
		this.setState({
			startDate: null,
			endDate: null
		})
	}

	render(){
		const {startDate, endDate, focusedInput} = this.state
		const {startLabel, endLabel} = this.props
		const numberOfMonths = this.props.numberOfMonths !== undefined ? this.props.numberOfMonths : 2
		const withPortal = this.props.withPortal !== undefined ? this.props.withPortal : false
		return (
			<DateRangePicker
				showClearDates
				noBorder
				isOutsideRange={day => {
					let today = new Date();
					return (day > today)
				} }
				startDateId="startDate"
				endDateId="endDate"
				minimumNights={0}
				startDatePlaceholderText={startLabel ? startLabel : "From"}
				endDatePlaceholderText={endLabel ? endLabel : "To"}
				displayFormat="DD/MM/YYYY"
				startDate={startDate}
				endDate={endDate}
				withPortal={withPortal}
				hideKeyboardShortcutsPanel
				onDatesChange={this.handleChange.bind(this)}
				focusedInput={focusedInput}
				numberOfMonths={numberOfMonths}
				onFocusChange={(focusedInput) => { this.setState({ focusedInput })}}
				customArrowIcon={<Icon style={{fontSize:"14px", color: "rgba(0,0,0,.54)"}}>play_arrow</Icon>}
			/>
		)
	}
}

export default DRP



// WEBPACK FOOTER //
// ./src/js/components/inputs/CustomRangePicker.js